<div class="container">
    <h1 class="animated-title">
        <span>{{ displayedTitleRow1 }}</span><span class="cursor">|</span>
    </h1>
    
    <form class="form" [formGroup]="service.newsletterForm" (ngSubmit)="register()">
        <mat-form-field>
            <input type="text" matInput placeholder="Nombre" formControlName="name">
            <mat-error
                *ngIf="this.service.newsletterForm.get('name')?.touched && this.service.newsletterForm.get('name')?.hasError('required')">
                El nombre es obligatorio
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <input type="email" matInput placeholder="Email" formControlName="email">
            <mat-error
                *ngIf="this.service.newsletterForm.get('email')?.touched && this.service.newsletterForm.get('email')?.hasError('required')">
                El email es obligatorio
            </mat-error>
            <mat-error
                *ngIf="this.service.newsletterForm.get('email')?.touched && this.service.newsletterForm.get('email')?.hasError('email')">
                Debe ser un email válido
            </mat-error>
        </mat-form-field>

        <mat-checkbox formControlName="acceptTerms">He leído y aceptado la <a href="/privacy" target="_blank">política de privacidad</a>.</mat-checkbox>
        <mat-error
            *ngIf="this.service.newsletterForm.get('acceptTerms')?.touched && this.service.newsletterForm.get('acceptTerms')?.hasError('required')">
            *Es obligatorio
        </mat-error>

        <div class="button">
            <button type="submit" mat-button [disabled]="!service.newsletterForm.valid">Inscribirme</button>
        </div>
    </form>

    <p class="contact">
    Envíanos tus sugerencias a: <a href="mailto:okhergo@atleticostats.es">okhergo&#64;atleticostats.es</a>
    </p>
    <div class="foto-container">
        <img src="/assets/H_FullColor.png" alt="Atlético Stats">
    </div>
</div>  